export default {
  distance(from, to) {
    var fromLat = from[0];
    var fromLon = from[1];
    var toLat = to[0];
    var toLon = to[1];

    var dLat = this.toRad(toLat - fromLat);
    var dLon = this.toRad(toLon - fromLon);
    var fromLat = this.toRad(fromLat);
    var toLat = this.toRad(toLat);

    var a = Math.pow(Math.sin(dLat / 2), 2) +
      (Math.pow(Math.sin(dLon / 2), 2) * Math.cos(fromLat) * Math.cos(toLat));
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return 6371 * c;
  },
  toRad(n) {
    return n * Math.PI / 180;
  },
  search(val, leaderList, that) {
    let v = val.toLowerCase()
    for (var i in leaderList) {
      for (var ii in leaderList[i]) {
        let s = leaderList[i][ii]
        if (
          s.fullname.toLowerCase().indexOf(v) > -1 ||
          s.community.toLowerCase().indexOf(v) > -1 ||
          s.address.toLowerCase().indexOf(v) > -1 ||
          s.city.toLowerCase().indexOf(v) > -1
        ) {
          leaderList[i][ii].hide = false
        } else {
          leaderList[i][ii].hide = true
        }
      }
    }
  },
  getLeader(list, localtion, that) {
    let items = []
    let num = 0
    let lists = {}
    var t
    for (var ii in list) {
      for (var iii in list[ii].list) {
        items[num++] = list[ii].list[iii]
      }
    }
    if (!localtion) {
      localtion = that._func.dataStorage('position')
    }
    items = this.getDistance(items, localtion)
    for (var i in items) {
      t = items[i].desc
      if (!lists[t]) {
        lists[t] = []
      }
      lists[t][lists[t].length] = items[i]
    }
    return lists
  },
  getDistance(leaderList, address) {
    let point = leaderList
    if (address && address.latitude) {
      for (var i in point) {
        point[i].distance = this.distance([address.latitude, address.longitude], [point[i].latitude, point[i].longitude]).toFixed(2)
        point[i].unit = ' Km'
      }
      point.sort(function(a, b) {
        return a['distance'] - b['distance'];
      })
    } else {
      for (var i in point) {
        point[i].distance = '-'
        point[i].unit = ' Km'
      }
    }
    return point
  },
  getInfoDistance(info, address) {
    if (address && address.latitude) {
      info.distance = this.distance([address.latitude, address.longitude], [info.latitude, info.longitude]).toFixed(2)
    } else {
      info.distance = '-'
    }
    info.unit = ' Km'
    return info
  },
  setUserDistance(that, url) {
    return new Promise((resolve, reject) => {
      let leader = that._func.strStorage('leader')
      let position = that._func.dataStorage('position')
      let t = this
      that._ajax.fetch(url, { id: leader, act: 'load', position: position }, that, false).then(res => {
        if (that._func.empty(res)) return
        if (res.city) {
          that.$store.commit('G_LEADER', t.getInfoDistance(res, position))
          if (!leader) {
            dataStorage('leader', res.id)
          }
          if (!position.latitude) {
            return resolve('post_code')
          }
        } else {
          if (!that._func.empty(res.d_area)) {
            var items = t.getLeaderList(res.d_area, position)
            for (var i in items) {
              for (var ii in items[i].list) {
                that.$store.commit('G_LEADER', t.getInfoDistance(items[i].list[ii], position))
                that._func.dataStorage('leader', items[i].list[ii].id)
                return resolve('close')
              }
            }
          } else {
            if (res.leader_emp) {
              that.$store.commit('G_LEADER_EMP', res.leader_emp)
              return resolve('leader_emp')
            } else {
              return resolve('post_code')
            }
          }
        }
        return resolve(12)
      })
    })
  },
  setLeader(item, that, position) {
    if (!position) {
      position = that._func.dataStorage('position')
    }
    that.$store.commit('G_LEADER', this.getInfoDistance(item, position))
    that._func.dataStorage('leader', item.id)
  },
  getLeaderList(list, localtion) {
    let items = []
    let num = 0
    let lists = {}
    var t
    for (var ii in list) {
      for (var iii in list[ii].list) {
        list[ii].list[iii].desc = list[ii].desc
        items[num++] = list[ii].list[iii]
      }
    }
    items = this.getDistance(items, localtion)
    for (var i in items) {
      t = items[i].desc
      if (!lists[t]) {
        lists[t] = {
          title: t,
          desc: items[i].desc,
          list: []
        }
      }
      lists[t].list[lists[t].list.length] = items[i]
    }
    return lists
  }
}
